<template>
  <div
    class="week-calendar-event"
    :class="{
      'week-calendar-event--draggable': canDrag,
      'week-calendar-event--active-drag': isActiveDrag,
      'week-calendar-event--saving': isSaving
    }"
    :style="style"
    :data-event-key="eventKey"
    :data-event-date="eventDate"
    @pointerdown="onPointerDown"
  >
    <week-appointment-card
      :data="appointment"
      :compact="true"
      @deleteMultipleAppointments="$emit('deleteMultipleAppointments', $event)"
      @openModalInsuranceList="$emit('openModalInsuranceList', $event)"
      @openModalExpenses="$emit('openModalExpenses', $event)"
      @infoWaitingList="$emit('infoWaitingList')"
    />
  </div>
</template>

<script>
import WeekAppointmentCard from '@/app/appointment/components/view/WeekAppointmentCard.vue';

export default {
  name: 'WeekCalendarEvent',
  components: {
    WeekAppointmentCard,
  },
  props: {
    appointment: {
      type: Object,
      required: true,
    },
    eventKey: {
      type: String,
      required: true,
    },
    eventDate: {
      type: String,
      required: true,
    },
    style: {
      type: Object,
      default: () => ({}),
    },
    canDrag: {
      type: Boolean,
      default: false,
    },
    isActiveDrag: {
      type: Boolean,
      default: false,
    },
    isSaving: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onPointerDown(event) {
      this.$emit('pointerdown', event, {
        appointment: this.appointment,
        key: this.eventKey,
        date: this.eventDate,
      });
    },
  },
};
</script>

<style lang="scss">
@import 'src/assets/scss/variables';

.week-calendar-event {
  position: absolute;
  padding: 0;
  min-height: 1.5rem;
  display: flex;
  align-items: stretch;
  box-sizing: border-box;
  user-select: none;
  opacity: 1;

  &:hover {
    opacity: 1;
  }
}

.week-calendar-event-group .week-calendar-event {
  position: static;
  flex-shrink: 0;
}

.week-calendar-event--draggable {
  cursor: grab;
}

.week-calendar-event--active-drag {
  opacity: 0.4;
}

.week-calendar-event--saving {
  opacity: 0.5;
  pointer-events: none;
}
</style>
